import dynamic from "next/dynamic";

export const ContentCards = dynamic(() => import("./component"));
